import React from "react";
import { REALTOR } from "../lib/brand";

export default function PageFrame({ pageNum, totalPages, label, children }) {
    return (
        <div className="relative bg-cream grain-bg book-page flex flex-col">
            <div className="relative z-10 flex-1 flex flex-col">{children}</div>
            <Footer pageNum={pageNum} totalPages={totalPages} label={label} />
        </div>
    );
}

function Footer({ pageNum, totalPages, label }) {
    return (
        <div className="relative z-10 mt-auto border-t border-hairline">
            <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-16 py-5 flex items-center justify-between text-xs font-sans text-muted2">
                <div className="hidden sm:block tracking-[0.18em] uppercase">
                    {REALTOR.name} · {REALTOR.companyRealty} + {REALTOR.companyMortgage}
                </div>
                <div className="sm:hidden tracking-[0.18em] uppercase">{REALTOR.name}</div>
                <div className="tracking-[0.18em] uppercase text-navy">
                    {label} <span className="text-muted2 mx-2">·</span> {pageNum} / {totalPages}
                </div>
            </div>
        </div>
    );
}
